import type { CSSProperties } from 'react';
import { cx } from '@/lib/cx';
import { ICONS, type IconName } from '../icons';
import styles from './Icon.module.css';

export type { IconName };

type Props = {
  name: IconName;
  /** The markup's `width` (px); height defaults to it, as in <lu-icon>. */
  size?: number;
  height?: number;
  className?: string;
  style?: CSSProperties;
  title?: string;
};

/** The design's <lu-icon icon="lucide:…" width="…">: an inline-block box holding a block SVG, stroke 2. */
export function Icon({ name, size = 16, height, className, style, title }: Props) {
  const Svg = ICONS[name];
  const h = height ?? size;
  return (
    <span
      className={cx(styles.icon, className)}
      style={{ width: size, height: h, ...style }}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      aria-label={title}
      data-icon={name}
    >
      <Svg width={size} height={h} strokeWidth={2} className={styles.svg} aria-hidden />
    </span>
  );
}
